import React, { CSSProperties } from 'react';
import { X } from 'react-feather';
import SideNavContent from './sideNavContent';

export type TabletSideNavDrawerProps = {
  /** Whether the drawer is open (i.e. sidebar is NOT collapsed on tablet) */
  isOpen: boolean;
  logoSrc: string;
  logoStyle: CSSProperties;
  /** Called when the backdrop or the close button is clicked */
  onClose: () => void;
};

const TabletSideNavDrawer: React.FC<TabletSideNavDrawerProps> = ({
  isOpen,
  logoSrc,
  logoStyle,
  onClose,
}) => {
  return (
    <>
      {/* Backdrop */}
      <div
        className={`fixed inset-0 bg-black/40 transition-opacity duration-300 ${
          isOpen
            ? 'opacity-100 pointer-events-auto'
            : 'opacity-0 pointer-events-none'
        }`}
        style={{ zIndex: 49 }}
        onClick={onClose}
        aria-hidden="true"
      />

      {/* Slide-in drawer panel */}
      <div
        className={`fixed top-0 left-0 flex flex-col justify-between h-screen px-4 py-2 bg-white transition-transform duration-300 shadow-2xl rounded-r-sm ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
        style={{ width: '220px', zIndex: 50 }}
      >
        <div className="flex flex-col gap-[37px]">
          {/* Logo row + close button */}
          <div className="flex items-center justify-between w-full">
            <img
              src={logoSrc}
              alt="pozytron logo"
              className="max-w-[138px] transition-transform duration-500 ease-in-out"
              style={logoStyle}
            />
            <button
              type="button"
              onClick={onClose}
              className="p-2 rounded-lg text-neutral-60 hover:text-neutral-10 hover:bg-neutral-95 transition-colors shrink-0"
              aria-label="Zamknij menu"
            >
              <X size={20} />
            </button>
          </div>

          {/* Nav items – always fully expanded in the drawer */}
          <SideNavContent isIconOnly={false} />
        </div>

        <img
          src="/navBarIllastration.svg"
          alt="pozytron logo"
          className="shrink-0"
        />
      </div>
    </>
  );
};

export default TabletSideNavDrawer;
